import { CoreExecutorResult, } from "../../core/index.js";
import { DataPsmExecutorResultFactory, loadDataPsmClass, } from "./data-psm-executor-utils.js";
import { DataPsmClass, DataPsmSchema } from "../model/index.js";
export async function executeDataPsmDeleteClass(reader, createNewIdentifier, operation) {
    let schema = null;
    const classes = [];
    for (const iri of await reader.listResources()) {
        const resource = await reader.readResource(iri);
        if (DataPsmSchema.is(resource)) {
            schema = resource;
        }
        if (DataPsmClass.is(resource)) {
            classes.push(resource);
        }
    }
    if (schema === null) {
        return DataPsmExecutorResultFactory.missingSchema();
    }
    const classToDelete = await loadDataPsmClass(reader, operation.dataPsmClass);
    if (classToDelete === null) {
        return CoreExecutorResult.createError(`Missing class '${operation.dataPsmClass}' to delete.`);
    }
    if (classToDelete.dataPsmParts.length > 0) {
        return CoreExecutorResult.createError("Only empty class can be deleted.");
    }
    for (const classItem of classes) {
        if (classItem.dataPsmExtends.includes(operation.dataPsmClass)) {
            return CoreExecutorResult.createError("Class is extended by other class.");
        }
    }
    return CoreExecutorResult.createSuccess([], [
        {
            ...schema,
            dataPsmRoots: removeValue(operation.dataPsmClass, schema.dataPsmRoots),
            dataPsmParts: removeValue(operation.dataPsmClass, schema.dataPsmParts),
        },
    ], [operation.dataPsmClass]);
}
function removeValue(valueToRemove, array) {
    return array.filter((value) => value !== valueToRemove);
}
//# sourceMappingURL=data-psm-delete-class-executor.js.map